import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card'
import { Button, ButtonText } from '@/components/ui/button'
import { EnvelopeIcon } from '@heroicons/react/16/solid'
import RegisterFooter from './RegisterFooter'
import { Link } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import GoogleLogin from '../login/GoogleLogin'
import useGetSocialAppId from '@/services/api/auth/useGetSocialAppId.ts'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import FacebookLoginButton from '../login/FacebookLoginButton'

export default function RegisterPage() {
  const navigate = useNavigate()
  const { data: googleApp, isLoading: isLoadingGoogleApp } = useGetSocialAppId({
    platform: 'google',
  })

  const [googleAuthInProgress, setGoogleAuthInProgress] = useState(false)
  const [facebookAuthInProgress, setFacebookAuthInProgress] = useState(false)

  if (isLoadingGoogleApp) return 'Loading...'

  return (
    <div className="pf-auth grid min-h-screen">
      <Card className="place-self-center">
        <CardHeader>
          <CardTitle>Create your account</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-3">
            <GoogleOAuthProvider clientId={googleApp?.platform_id}>
              <GoogleLogin
                isLoading={googleAuthInProgress}
                setIsLoading={setGoogleAuthInProgress}
                onSuccess={() => {
                  navigate('/')
                }}
              />
            </GoogleOAuthProvider>
            <FacebookLoginButton
              isLoading={facebookAuthInProgress}
              setIsLoading={setFacebookAuthInProgress}
              onSuccess={() => {
                navigate('/')
              }}
            />
            <Link
              to="/register/email"
              className="text-txt-secondary no-underline"
            >
              <Button variant="outline" size="lg" className="w-full">
                <EnvelopeIcon className="text-txt-primary" />

                <ButtonText>Continue with Email</ButtonText>
              </Button>
            </Link>
          </div>
        </CardContent>
        <CardFooter>
          <RegisterFooter />
        </CardFooter>
      </Card>
    </div>
  )
}
